var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_vm._t("table-header")],2)]),_c('tbody',[_vm._t("table-body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }